"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HyperlinkDefaultProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Hyperlink = function Hyperlink(_ref) {
  var target = _ref.target,
      useLink = _ref.useLink,
      useLight = _ref.useLight,
      children = _ref.children,
      classNames = _ref.classNames;
  var hyperlinkClassnames = {
    'hyperlink-component': true,
    'hyperlink-component--secondary': useLight
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(hyperlinkClassnames, classNames)
  }, useLink ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: "hyperlink-component__link",
    to: target
  }, children) : /*#__PURE__*/_react.default.createElement("a", {
    className: "hyperlink-component__link",
    href: target
  }, children));
};

Hyperlink.propTypes = {
  useLink: _propTypes.default.bool.isRequired,
  useLight: _propTypes.default.bool.isRequired,
  target: _propTypes.default.string.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]).isRequired,
  classNames: _propTypes.default.any
};
var HyperlinkDefaultProps = {
  useLink: false,
  useLight: false
};
exports.HyperlinkDefaultProps = HyperlinkDefaultProps;
Hyperlink.defaultProps = HyperlinkDefaultProps;
var _default = Hyperlink;
exports.default = _default;